export default "__VITE_ASSET__uJU$uQiu__"